import { RouteLocationNormalized, RouteRecordRaw } from 'vue-router'

import { useCachedUser } from '@/modules/user'

import {
  casos,
  channel,
  eita,
  exames,
  historico,
  pda,
  perfil,
  registro,
  risco,
  roteiro,
  timeline,
  wanda
} from './metaComponents'

export const pillarsRoutes: RouteRecordRaw[] = [
  {
    path: '/member/:personId/pillars',
    props: {
      primeiraAba: undefined,
      segundaAba: undefined,
      terceiraAba: undefined,
      channelId: undefined,
      appointmentId: undefined
    },
    name: 'Pillars',
    component: () =>
      import(/* webpackChunkName: "pillars" */ '@/views/PillarsView.vue'),
    meta: {
      onlyLoggedIn: true,
      isPillars: true,
      components: {
        perfil,
        historico,
        channel,
        roteiro,
        timeline,
        wanda,
        casos,
        pda,
        exames,
        eita,
        risco,
        registro
      }
    },
    beforeEnter: (
      _to: RouteLocationNormalized,
      _from: RouteLocationNormalized,
      next: (arg0?: string | undefined) => void
    ) => {
      const { getUser } = useCachedUser()
      const user = getUser()

      if (user) {
        if (user.roles[0] === 'COMMUNITY') {
          next('/')
          return
        }
      }

      next()
    }
  },
  {
    path: '/pillars',
    name: 'PillarsPlaceholder',
    component: () =>
      import(
        /* webpackChunkName: "pillars" */
        '@/views/PillarsView.vue'
      ),
    meta: {
      onlyLoggedIn: true,
      isPillars: true,
      isEmptyPillars: true
    }
  },
  {
    path: '/member/:personId/especialista',
    name: 'SpecialistPillars',
    component: () =>
      import(
        /* webpackChunkName: "pillars-specialist" */
        '@/views/SpecialistPillars.vue'
      ),
    props: true,
    meta: {
      onlyLoggedIn: true,
      isPillars: true,
      components: {
        perfil,
        historico,
        timeline,
        exames,
        pda
      }
    }
  },
  {
    path: '/member/:personId/matriciamento',
    name: 'SpecialistOpinionPillars',
    component: () =>
      import(
        /* webpackChunkName: "pillars-specialist" */
        '@/views/SpecialistPillars.vue'
      ),
    props: true,
    meta: {
      onlyLoggedIn: true,
      isPillars: true,
      components: {
        perfil,
        historico,
        timeline,
        exames,
        pda
      }
    }
  }
]
